export var isFormElement = function (unknown) {
    return !!unknown && !!unknown.code && !!unknown.kind && !!unknown.$type;
};
// form event types
export var ExtraActionType;
(function (ExtraActionType) {
    ExtraActionType["LOADING"] = "LOADING";
    ExtraActionType["ERROR"] = "ERROR";
})(ExtraActionType || (ExtraActionType = {}));
//# sourceMappingURL=form.types.js.map